export default __webpack_public_path__ + "static/media/AT&T.22288e17.png";